import React, { Component } from "react";
import reload from "../../image/reload.png";
import "../../style/common/reload.scss";
class Reload extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { reloadingShow } = this.props;
    return (
      <div className={`reload-mask ${reloadingShow ? "show" : ""}`}>
        <div className="reload">
          <div className="box">
            <img src={reload} alt="" className="reload-img" />
            <p>Connecting to the payment gateway...</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Reload;
